import _classCallCheck from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _typeof from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.json.stringify.js";

/*
 *@author   tonicli
 *@date     2016/9/16
 */
import { buildUrl } from './url';
var PROTOCOL = /^(http|https):$/.test(location.protocol) ? location.protocol : 'https:';
var BOSS_URL = "".concat(PROTOCOL, "//btrace.qq.com/kvcollect");
var ATTA_URL = "".concat(PROTOCOL, "//h.trace.qq.com/kv");

function _handle() {}

function _isObject(value) {
  var type = _typeof(value);

  return !!value && (type === 'object' || type === 'function');
}

function _mapValues(obj, iter) {
  if (!_isObject(obj)) {
    return obj;
  }

  var retObj = {};
  Object.keys(obj).forEach(function (p) {
    retObj[p] = iter(obj[p]);
  });
  return retObj;
}

function _encodeDollor2(content) {
  var useAtta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (typeof content !== 'string') {
    return content;
  }

  var replacement = useAtta ? '\\$' : '|||';
  return content.replace(/\$/g, replacement);
}
/**
 *@param cfg object {bossId:xxx, pwd: xxx}
 */


var Boss = /*#__PURE__*/function () {
  function Boss(cfg) {
    _classCallCheck(this, Boss);

    if (!cfg || !cfg.bossId || !cfg.pwd && parseInt(cfg.pwd, 10) !== 0) {
      throw new Error('[report.Boss]bossId and pwd is required');
    }

    this._cfg = cfg;
    this.useAtta = false;

    if (cfg.useAtta || !cfg.bossId.toString().match(/^[1-9][0-9]{2,5}$/)) {
      // 所有存量bossid都为数字，如果非数字认为是Attaid
      this.useAtta = true;
    }

    if (!this.useAtta) {
      this._baseUrl = buildUrl(cfg.baseUrl || BOSS_URL, {
        BossId: cfg.bossId,
        Pwd: cfg.pwd
      });
    } else {
      this._baseUrl = buildUrl(cfg.baseUrl || ATTA_URL, {
        attaid: cfg.bossId,
        token: cfg.pwd
      });
    }
  }

  _createClass(Boss, [{
    key: "report",
    value: function report(params) {
      this._doReport(this.buildReportUrl(params));

      return this;
    }
  }, {
    key: "buildReportUrl",
    value: function buildReportUrl(params) {
      var _this = this;

      var url = buildUrl(this._baseUrl, _mapValues(params, function (v) {
        if (_isObject(v)) {
          try {
            v = JSON.stringify(v);
          } catch (e) {}
        }

        return _encodeDollor2(v, _this.useAtta);
      }), true);
      return _encodeDollor2(url, this.useAtta);
    }
  }, {
    key: "setBaseUrl",
    value: function setBaseUrl(url) {
      this._baseUrl = url;
      return this;
    }
  }, {
    key: "getBaseUrl",
    value: function getBaseUrl() {
      return this._baseUrl;
    }
  }, {
    key: "_doReport",
    value: function _doReport(url) {
      var reportObject = document.createElement('img');
      reportObject.onerror = _handle;
      reportObject.onload = _handle;
      reportObject.onabort = _handle;
      reportObject.src = url;
      return this;
    }
  }, {
    key: "_encodeDollor",
    value: function _encodeDollor(content, useAtta) {
      return _encodeDollor2(content, useAtta);
    }
  }]);

  return Boss;
}();

export { Boss as default };